module.exports = __webpack_public_path__ + "static/media/25.92e04eb6.mp3";